<template>
	<td
		:class="{
			'base-table__td--primary': !!primary,
		}"
	>
		<slot />
	</td>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	inject: ['$table'],

	props: {
		field: {
			type: String,
			default: null,
		},
		label: {
			type: String,
			default: '',
		},
		primary: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			isTableColumn: true,
		};
	},

	created() {
		const { $table } = this as any;

		if (!$table) {
			throw new Error('You should wrap bTableColumn on a bTable');
		}

		$table.registerColumn(this.$props);
	},

	methods: {
		getColumnProps() {
			return this.$props;
		},
	},
});
</script>
